import React, { useEffect, useMemo, useState } from "react";
import { catalogById, getChildrenOf, getPlanets } from "../../data/catalog";
import { sun } from "../../data/sun";
import { useSceneStore } from "../../store/sceneStore";

export function BodySelector() {
  const selectedBodyId = useSceneStore((s) => s.selectedBodyId);
  const focusBody = useSceneStore((s) => s.focusBody);
  const planets = useMemo(() => getPlanets(), []);

  const initialPlanetId = useMemo(() => {
    const selected = selectedBodyId ? catalogById.get(selectedBodyId) : null;
    if (!selected) return "earth";
    if (selected.type === "star" || selected.type === "planet") return selected.id;
    return selected.parentId ?? "earth";
  }, []);

  const [planetOrSunId, setPlanetOrSunId] = useState(initialPlanetId);
  const [moonId, setMoonId] = useState("");

  const moonsOfSelection = useMemo(() => {
    if (!planetOrSunId || planetOrSunId === sun.id) return [];
    return getChildrenOf(planetOrSunId).sort((a, b) =>
      a.name.localeCompare(b.name, "pt"),
    );
  }, [planetOrSunId]);

  useEffect(() => {
    if (moonsOfSelection.length === 0) {
      setMoonId("");
      return;
    }
    setMoonId((current) =>
      moonsOfSelection.some((m) => m.id === current)
        ? current
        : moonsOfSelection[0].id,
    );
  }, [moonsOfSelection]);

  return (
    <div className="tls-astro-control-block">
      <label htmlFor="tls-astro-planet">Sol e planetas</label>
      <div className="tls-astro-select-row">
        <select
          id="tls-astro-planet"
          value={planetOrSunId}
          onChange={(e) => setPlanetOrSunId(e.target.value)}
        >
          <option value={sun.id}>{sun.name}</option>
          {planets.map((planet) => (
            <option key={planet.id} value={planet.id}>
              {planet.name}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="tls-astro-go-btn"
          onClick={() => {
            if (planetOrSunId) focusBody(planetOrSunId, 0.5);
          }}
        >
          IR
        </button>
      </div>

      <label htmlFor="tls-astro-moon">Luas</label>
      <div className="tls-astro-select-row">
        <select
          id="tls-astro-moon"
          value={moonId}
          disabled={moonsOfSelection.length === 0}
          onChange={(e) => setMoonId(e.target.value)}
        >
          {moonsOfSelection.length === 0 ? (
            <option value="">Sem luas</option>
          ) : (
            moonsOfSelection.map((moon) => (
              <option key={moon.id} value={moon.id}>
                {moon.name}
              </option>
            ))
          )}
        </select>
        <button
          type="button"
          className="tls-astro-go-btn"
          disabled={!moonId || moonsOfSelection.length === 0}
          onClick={() => {
            if (moonId) focusBody(moonId, 0.5);
          }}
        >
          IR
        </button>
      </div>
      {moonsOfSelection.length > 0 && (
        <span className="tls-astro-muted">
          {moonsOfSelection.length} lua(s) de{" "}
          {catalogById.get(planetOrSunId)?.name ?? "—"}
        </span>
      )}
    </div>
  );
}
